import React from 'react';
import { AdtEventListContainer, 
	NotificationListContainer,
	Route, Switch, Redirect } from 'gwx-voyager-components';



const Reporting = ({match}) => (
	<Switch>
		<Route exact path={`${match.path}/adts`} render={() => <AdtEventListContainer source={'Client Admin'} />} />
		<Route exact path={`${match.path}/notifications`} render={() => <NotificationListContainer source={'Client Admin'} />} />
		<Redirect exact from={`${match.path}`} to={`${match.path}/adts}`} />
		<Redirect to='/pageNotFound' />
	</Switch>
);

export default Reporting;
